import styled from 'styled-components';

export const PriceLabel = styled.span`
  font-size: 10px;
  color: #666;
`;
